// extracted by css-extract-rspack-plugin
export default {"spacer":"spacer--ljKHj4ZXSz8vAtIK"};